export const TRANSLATIONS_EN = {
  Copyright: "Copyright",
  all_rights_reserved: "All Rights Reserved",
  menu_title_home: "Home",
  menu_title_who_we_are: "Who We Are",
  menu_title_about_us: "About Us",
  menu_title_vision: "Our Vision",
  menu_title_members: "Board Members",
  menu_title_partners: "Partners in Success",
  menu_title_shareholders: "Shareholders",
  menu_title_coupons: "Coupons Payments",
  menu_title_issues: "Issues",
  issue: "Issue No. ",
  menu_title_contact_us: "Contact Us",
  language: " ع ",
  home_page_title_pt1: "Securitization",
  home_page_title_pt2: "Experts in",
  home_page_title_pt3: "Egypt",
  coupons_pt1: "Coupons",
  coupons_pt2: "Payments",
  about_us_pt1: "About",
  about_us_pt2: "Us",
  about_us_text:
    "Capital Securitization Company (CSC) is an Egyptian\njoint stock company that was established in accordance\nwith the provisions of Law No.95 of year 1992 and its\nexecutive regulations.\n\nThe establishment of CSC was also pursuant to the Companies\nIncorporation Committee’s decision of the FRA in its 314th\nsession on the 26th of December in 2018.\n\nIn 2019, the company was registered in the Commercial\nRegister under No.245129, and it has been working for four\nyears in the field of securitizing future financial rights in\nthe Egyptian local market, in cooperation with the largest\nEgyptian banks and institutions, such as Misr for Central\nClearing, Depository and Registry (MCDR), the Egyptian\nExchange (EGX), and Middle East Rating and Investors\nService (MERIS), under the supervision of the FRA and the\nCentral Auditing Organization.",
  our_vision_pt1: "Our",
  our_vision_pt2: "Vision",
  our_vision_text:
    "To be the largest securitization company in Egypt that\ncontributes to the implementation of financing programs\nfor mega Egyptian projects in all fields and at all levels; the\ngovernment sector level or at the private sector one.\n\nWe relentlessly aim at abiding by a strong system of laws,\nin addition to complying with the legislation and decisions\nregulating the market, which were issued by the Financial\nRegulatory Authority (FRA).",

  board_member_pt1: "Board ",
  board_member_pt2: "Members",
  Partners_In_Success_pt1: "Partners ",
  Partners_In_Success_pt2: "In Success",
  shareholders: "Shareholders",
  Shares: "Shares",
  The_value_in_Egyptian_pounds: "The value in Egyptian pounds",
  Currency_fulfilled: "Currency fulfilled",
  The_Ratio: "The Ratio",
  read_more: "Read More",
  Total_Amount: "Total Amount",
  Issuance_Date: "Issuance Date",
  Maturity_Date: "Maturity Date",
  Interest_Rate: "Interest Rate",
  Portfolio_Referrer: "Portfolio Referrer",
  Custodian: "Custodian",
  Collector: "Collector",
  The_nominal_value_of_the_bonds_upon_issuance:
    "The nominal value of the bonds upon issuance",
  Through_Misr_for_Central_clearing:
    "Through Misr for Central clearing, depositing  and registry",

  contact_us_pt1: "Contact ",
  contact_us_pt2: "Us",
  Full_Name: "Full Name",
  phone: "Phone",
  Email: "Email",
  Subject: "Subject",
  how_help_you: "How Can We Help You?",
  submit_btn: "Submit",
  alert_name: "Name can't be empty",
  alert_Phone: "Phone can't be empty",
  alert_Email: "Email can't be empty",
  alert_Subject: "Subject can't be empty",
  alert_Comment: "Comment can't be empty",
  Successfully_sent_message: "Successfully sent message!",
  failed_sent_message: "Failed to send email!",
};
